export type GreetingPeriod = 'Morning' | 'Afternoon' | 'Evening';

const AFTERNOON_STARTS_AT_HOUR = 12;
const EVENING_STARTS_AT_HOUR = 18;

export function resolveGreetingPeriod(hour: number): GreetingPeriod {
  if (hour >= EVENING_STARTS_AT_HOUR) {
    return 'Evening';
  }
  if (hour >= AFTERNOON_STARTS_AT_HOUR) {
    return 'Afternoon';
  }
  return 'Morning';
}
